/**
 */
define(function () {
  return {
    //手机号正则
    isPhone: function (str) {
      return /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/.test(str);
    },
    //验证码正则 四位正整数
    isCode: function (str, len) {
      if (len === 4) {
        return /^[0-9]\d{0,4}$/.test(str);
      }
      if (len === 6) {
        return /^[0-9]\d{0,6}$/.test(str);
      }
    },
    //邮箱验证
    isEmail: function (str) {
      return /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(str);
    },
    //0-9数字
    isNumber: function (str) {
      return /^[0-9]+$/.test(str);
    },
    isCarnumber: function (str) {
      return /^[\u4e00-\u9fa5]{1}[A-Z]{1}[A-Z_0-9]{5}$/.test(str);
    },
    // 数字与英文字母
    isNumOrWord: function (str) {
      return /^[A-Za-z0-9]+$/.test(str);
    }
  }
});



// WEBPACK FOOTER //
// ./src/assets/js/RegExp.js